import { Box, Button, Typography } from "@mui/material";
import React from "react";
import * as XLSX from "xlsx";
import { Formik, Form } from "formik";
import useApiCaller from "hooks/apiCaller";
import { useSelector } from "react-redux";
import { toast, } from "react-toastify";

function UploadNomination() {
    const apiCaller = useApiCaller();
    const {
        data: { trainingTypes },
        loading,
    } = useSelector((state) => state.trainingTypePageSlice);
    const trainingTypesArr = trainingTypes.map((item) => item.trainingName)

    const handleFileUpload = async (event, setFieldValue) => {
        const file = event.currentTarget.files[0];
        if (!file) return;

        const reader = new FileReader();
        reader.readAsBinaryString(file);

        reader.onload = async (e) => {
            const data = e.target.result;
            const workbook = XLSX.read(data, { type: "binary" });
            const sheetName = workbook.SheetNames[0];
            const sheet = workbook.Sheets[sheetName];
            const jsonData = XLSX.utils.sheet_to_json(sheet);

            const mappedData = jsonData.map((row) => ({
                trainingName: row["Training Name"]?.trim() || "",
                employeeId: Number(row["Employee ID"]) || undefined,
                nominationCount: Number(row["Nomination Count"]) || undefined,
            }));

            console.log("Mapped Data:", mappedData);
            await setFieldValue("nominationData", mappedData);
        };
    };

    // Custom validation function
    const validate = (values) => {
        const errors = {};

        if (!values.nominationData || values.nominationData.length === 0) {
            errors.nominationData = "Please upload a valid nomination file.";
        } else {
            const rowErrors = values.nominationData.map((row, index) => {
                const rowError = {};

                if (!row.trainingName) {
                    rowError.trainingName = "Training Name is required.";
                } else if (!trainingTypesArr.includes(row.trainingName)) {
                    rowError.trainingName = "Training Name does not exist.";
                }

                if (!row.employeeId || isNaN(row.employeeId)) {
                    rowError.employeeId = "Valid Employee ID is required.";
                }

                if (
                    row.nominationCount === undefined ||
                    isNaN(row.nominationCount) ||
                    row.nominationCount <= 0
                ) {
                    rowError.nominationCount = "Nomination Count must be a positive number.";
                }

                // Return error object if there are errors, otherwise return undefined
                return Object.keys(rowError).length > 0 ? rowError : undefined;
            });

            const hasErrors = rowErrors.some((e) => e !== undefined);
            if (hasErrors) {
                errors.nominationData = rowErrors;
            }
        }

        return errors;
    };

    return (
        <>
            
            <Formik
                initialValues={{ nominationData: [] }}
                validate={validate}
                onSubmit={async (values, { setSubmitting }) => {
                    console.log("Submitted Values:", values);
                    try {
                        const response = await apiCaller.post("/super-user/update-nomination", values);
                        if (response.data.status === 'success') {
                            toast.success("Nomination Updated Successfully", {
                                theme: "colored",
                            });
                        }
                    } catch (error) {
                        console.error("Error fetching dashboards:", error);
                        toast.error(`Error while updating nominations - ${error} `, {
                            theme: "colored",
                        });
                    }
                    setSubmitting(false);
                }}
            >
                {({ setFieldValue, values, errors, isSubmitting }) => (
                    <Form>
                        <Box mt={2}>
                            <Button
                                variant="outlined"
                                href="/assets/NominationFileTemplate.xlsx"
                                download="Nomination_Template.xlsx"
                            >
                                Download Nomination Template
                            </Button>
                        </Box>

                        <Box mt={2}>
                            <Typography variant="subtitle1">
                                Upload Nomination file (Excel/CSV) *
                            </Typography>
                            <input
                                type="file"
                                accept=".csv,.xlsx"
                                onChange={(event) =>
                                    handleFileUpload(event, setFieldValue)
                                }
                                style={{ display: "block", marginTop: "8px" }}
                            />
                            {typeof errors.nominationData === "string" ? (
                                <Typography color="error" variant="caption">
                                    {errors.nominationData}
                                </Typography>
                            ) : Array.isArray(errors.nominationData) && (
                                <Box mt={2}>
                                    {errors.nominationData.map((rowError, index) =>
                                        rowError ? (
                                            <Box key={index} mb={1}>
                                                <Typography color="error" variant="caption">
                                                    Row {index + 1}:
                                                    <ul style={{ margin: 0, paddingLeft: 16 }}>
                                                        {Object.entries(rowError).map(([field, msg]) => (
                                                            <li key={field}>{field}: {msg}</li>
                                                        ))}
                                                    </ul>
                                                </Typography>
                                            </Box>
                                        ) : null
                                    )}
                                </Box>
                            )}

                        </Box>

                        <Button
                            type="submit"
                            variant="contained"
                            fullWidth
                            sx={{ mt: 2 }}
                            disabled={isSubmitting}
                        >
                            Submit
                        </Button>
                    </Form>
                )}
            </Formik>
        </>

    );
}

export default UploadNomination;
